// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
  line-height: 1.5;
  font-weight: 400;

  /* VS Code Dark Theme colors */
  color-scheme: dark;
  color: #d4d4d4;
  background-color: #1e1e1e;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100%;
}

a {
  font-weight: 500;
  color: #3794ff;
  text-decoration: inherit;
}
a:hover {
  color: #82afff;
}

body {
  margin: 0;
  display: flex;
  place-items: center;
  min-width: 320px;
  min-height: 100vh;
}

h1 {
  font-size: 3.2em;
  line-height: 1.1;
}

button {
  border-radius: 4px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #0e639c; /* VS Code blue */
  color: #ffffff;
  cursor: pointer;
  transition: background-color 0.25s, border-color 0.25s;
}
button:hover {
  background-color: #1177bb;
  border-color: #3794ff;
}
button:focus,
button:focus-visible {
  outline: 2px solid #3794ff;
}

/* Optionally adjust for light mode */
@media (prefers-color-scheme: light) {
  :root {
    color: #1e1e1e;
    background-color: #f3f3f3;
  }
  a:hover {
    color: #2563eb;
  }
  button {
    background-color: #0e639c;
    color: #ffffff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,gBAAgB;EAChB,gBAAgB;;EAEhB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,yBAAyB;;EAEzB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB,EAAE,iBAAiB;EAC5C,cAAc;EACd,eAAe;EACf,sDAAsD;AACxD;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF","sourcesContent":[":root {\n  font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;\n  line-height: 1.5;\n  font-weight: 400;\n\n  /* VS Code Dark Theme colors */\n  color-scheme: dark;\n  color: #d4d4d4;\n  background-color: #1e1e1e;\n\n  font-synthesis: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-text-size-adjust: 100%;\n}\n\na {\n  font-weight: 500;\n  color: #3794ff;\n  text-decoration: inherit;\n}\na:hover {\n  color: #82afff;\n}\n\nbody {\n  margin: 0;\n  display: flex;\n  place-items: center;\n  min-width: 320px;\n  min-height: 100vh;\n}\n\nh1 {\n  font-size: 3.2em;\n  line-height: 1.1;\n}\n\nbutton {\n  border-radius: 4px;\n  border: 1px solid transparent;\n  padding: 0.6em 1.2em;\n  font-size: 1em;\n  font-weight: 500;\n  font-family: inherit;\n  background-color: #0e639c; /* VS Code blue */\n  color: #ffffff;\n  cursor: pointer;\n  transition: background-color 0.25s, border-color 0.25s;\n}\nbutton:hover {\n  background-color: #1177bb;\n  border-color: #3794ff;\n}\nbutton:focus,\nbutton:focus-visible {\n  outline: 2px solid #3794ff;\n}\n\n/* Optionally adjust for light mode */\n@media (prefers-color-scheme: light) {\n  :root {\n    color: #1e1e1e;\n    background-color: #f3f3f3;\n  }\n  a:hover {\n    color: #2563eb;\n  }\n  button {\n    background-color: #0e639c;\n    color: #ffffff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
